import * as React from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { SearchPersonItem, SearchResponse } from '@/apiTypes/types';
import { Locale } from '@/lib/enums/locale.enum';
import { getInternalLink } from '@/lib/helpers/getInternalLink';
import { getSearchPersonLabel } from '@/lib/search/getSearchPersonLabel';

interface IProps {
  persons: SearchResponse['persons']['items'];
}

const SearchPersonsList: React.FC<IProps> = ({ persons }) => {
  const { i18n } = useTranslation();
  return (
    <React.Fragment>
      {persons.map((person: SearchPersonItem) => (
        <tr key={person.id}>
          <td>
            <Link
              href={getInternalLink('Person', person.id, i18n.language as Locale, person.name)}
              prefetch={false}
              draggable={false}
            >
              {getSearchPersonLabel(person)}
            </Link>
          </td>
          <td className="align-right">{person.dateOfBirth}</td>
        </tr>
      ))}
    </React.Fragment>
  );
};

export default SearchPersonsList;
